module.exports = __webpack_public_path__ + "images/locator/icon-juul-premier-logo-white-50a1821e.svg";